import React from 'react';
import { CardConsultUserStyle } from './style';

export default function CardConsultUser({ user }) {
  return (
    <CardConsultUserStyle>
      <p>{user.name}</p>
      <a href={`consultar-faturamentos/${user._id}`}>Consultar</a>
    </CardConsultUserStyle>
  );
}
